import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, FormControl, FormControlLabel, Link, Radio, RadioGroup, TextField } from "@mui/material";
import { ReactComponent as AddUser } from "assets/AddUser.svg";
import { ReactComponent as CloseIconSmall, ReactComponent as CrossNew } from "assets/CrossNew.svg";
import { ReactComponent as FileIcon } from "assets/FileIcon.svg";
import AutocompleteInncode from "components/common/AutocompleteInncode";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import {
  createFilterByType,
  fetchCorpSavedFilters,
  setSavedFilterByType
} from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { resetPageModifiedFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import { fetchMyLists, updateInncodeUploadList, uploadMyList } from "components/features/SME/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { cloneDeep, isNull } from "lodash";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { addDynamicId, onDownloadClick } from "utils/CommonFunctions";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import {
  setCreateListError,
  setCreatedSuccess,
  setIsCreateInnCodeModal,
  setSelectedListCategory,
  setSelectedList as setSelectedListRedux
} from "../../Corp/CorpUser.Slice";
import MapUserToInnCode from "../AddUser";
import "./CreateList.scss";

interface InncodeInterface {
  name: string;
  innCode: string;
  user: any;
}

interface CreateListProps {
  listType: string;
  setInvalidInncodes: any;
  invalidInnCodes: any;
  setUploadFileDetails: any;
  uploadFileDetails: any;
}

const CreateList = (props: CreateListProps) => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const { listType, setInvalidInncodes, setUploadFileDetails } = props;
  const [inncodeList, setInnCodeList] = React.useState<InncodeInterface[] | []>([]);
  const [isAddUserOpen, setAddUserOpen] = useState<boolean>(false);
  const [selectedInnCode, setSelectedInnCode] = useState<string>("");
  const [selectedList, setSelectedList] = useState<string>("PROPERTY_LIST");
  const [memberListIndex, setMemberListIndex] = useState<number>(0);
  const [innCodeAssignee, setInnCodeAssignee] = useState<any>();
  const [file, setFile] = useState<FileList | null>(null);
  const [inputFieldData, setInputFieldData] = useState({
    name: "",
    desc: ""
  });
  const isCreateInnCodeModal = useAppSelector((state) => state.CorpDashboard.isCreateInnCodeModal);
  const createListError = useAppSelector((state) => state.CorpDashboard.createListError);
  const isConsultant: any = useAppSelector((state) => state.app.loggedInUserDetails.isConsultant);
  const savedFilter = useAppSelector((state) => state.filters?.savedFilter);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedList((event.target as HTMLInputElement).value);
    resetData();
  };

  function getUserHltIdsByInnCode(innCode: string) {
    const filteredData = inncodeList.filter((obj) => obj.innCode === innCode && obj.user && obj.user.hltId);
    return filteredData.map((obj) => obj.user.hltId);
  }

  const handleMemberList = (value: any) => {
    const clonedInnCodeList = cloneDeep(inncodeList);
    clonedInnCodeList[memberListIndex].user = value;
    setInnCodeList(clonedInnCodeList);
  };

  const handleInncodeChange = (val: InncodeInterface) => {
    const clonedInncode: InncodeInterface[] = cloneDeep(inncodeList);

    if (val) {
      clonedInncode.unshift(val);
      setInnCodeList(clonedInncode);
    }
  };

  const deleteInnCode = (index: number, innCode: InncodeInterface) => {
    const clonedSelectedInnCode = cloneDeep(inncodeList);
    clonedSelectedInnCode.splice(index, 1);
    setInnCodeList(clonedSelectedInnCode);
  };

  const handleAddUser = (inncode: string, index: number) => {
    const assignee = getUserHltIdsByInnCode(inncode);
    setInnCodeAssignee(assignee);
    setSelectedInnCode(inncode);
    setAddUserOpen(true);
    setMemberListIndex(index);
  };

  const handleFileChange = (e: any) => {
    const fileExtension = e.target.files[0].name.split(".")[1];
    setFile(e.target.files);
  };

  const handleInputChange = (fieldName: string, value: string) => {
    setInputFieldData((prevState) => ({
      ...prevState,
      [fieldName]: value
    }));
  };

  const resetData = () => {
    setInputFieldData({ name: "", desc: "" });
    setInnCodeList([]);
    setAddUserOpen(false);
    setSelectedInnCode("");
    setMemberListIndex(0);
    setFile(null);
    dispatch(setCreateListError({ isError: false, messages: "", isInputError: false }));
  };

  const handleSubmit = () => {
    const formData = new FormData();
    const fileData = file?.[0];
    fileData && formData.append("file", fileData);
    formData.append("name", inputFieldData.name);
    formData.append("type", selectedList);
    formData.append("description", inputFieldData.desc);
    if (listType === "upload") {
      ScUploadListSubmit(formData);
    } else if (selectedList === "SC_LIST") {
      ScCreateList();
    } else {
      savedCreateList();
    }
  };

  const selectListAndType = (filter: any, filterRes: any, type: any) => {
    const lastIndex = filter.findLastIndex((item: any) => item.isFlagged === "Y");
    if (lastIndex > -1) {
      filter.splice(lastIndex + 1, 0, filterRes);
    } else {
      filter.splice(0, 0, filterRes);
    }
    const payload = {
      data: filter,
      type: type
    };
    dispatch(setSelectedListCategory(type));
    dispatch(setSelectedListRedux(filterRes));
    dispatch(
      resetPageModifiedFilter({
        pageName: [filterPage.listDisplay, filterPage.consultantListDisplay]
      })
    );
    dispatch(setSavedFilterByType(payload));
  };

  const ScUploadListSubmit = (formData: any) => {
    clearDispatchErrorSuccess();
    dispatch(uploadMyList(formData)).then((response: any) => {
      dispatch(fetchMyLists({ searchText: "" }));
      const type = selectedList !== "PROPERTY_LIST" ? "consultant" : "static";
      const listType = selectedList !== "PROPERTY_LIST" ? "scList" : "propertyList";
      const details = response.payload?.errors?.[0]?.detail;
      if (!response?.error) {
        if (response?.payload?.invalidMappings?.length) {
          const scList = response?.payload;
          setUploadFileDetails({ id: scList?.scList?.id, name: scList?.scList?.name });
          const newRes = addDynamicId(response?.payload?.invalidMappings);
          if (selectedList !== "PROPERTY_LIST") {
            setInvalidInncodes(newRes);

            const submitedList = response?.payload?.scList;
            if (submitedList.id) {
              const staticFilter = cloneDeep(savedFilter.consultant);
              selectListAndType(staticFilter, submitedList, "consultant");
            }
          } else {
            const submitedList = response?.payload?.propertyList;
            dispatch(setSelectedListCategory(type));
            dispatch(setSelectedListRedux(submitedList));
            dispatch(
              resetPageModifiedFilter({
                pageName: [filterPage.listDisplay, filterPage.consultantListDisplay]
              })
            );
            dispatch(setCreatedSuccess({ isCreated: true, message: translate("list.uploadInncode.success") }));
            fetchFilters();
          }
          dispatch(setIsCreateInnCodeModal(false));
        } else {
          dispatch(setCreatedSuccess({ isCreated: true, message: translate("list.uploadInncode.success") }));
          const submitedList = response?.payload?.[listType];
          const staticFilter = cloneDeep(savedFilter[type]);
          selectListAndType(staticFilter, submitedList, type);
        }
        dispatch(setIsCreateInnCodeModal(false));
      } else {
        dispatch(
          setCreateListError({
            isError: true,
            message: details,
            isInputError:
              details === translate("list.inncodes.already.exist") ||
              details === translate("list.property.already.exist")
          })
        );
      }
    });
  };

  const ScCreateList = async () => {
    const innCodeMapping = inncodeList.map((inncode: any, index: number) => {
      return {
        innCode: inncode.innCode,
        hltId: inncode?.user?.hltId || ""
      };
    });
    const request = {
      id: null,
      name: inputFieldData.name,
      description: inputFieldData.desc,
      mappings: innCodeMapping,
      formUpload: true
    };
    clearDispatchErrorSuccess();
    const response = await dispatch(updateInncodeUploadList(request));
    if (response?.payload?.errors) {
      const details = response.payload.errors?.[0]?.detail;
      dispatch(
        setCreateListError({
          isError: true,
          message: details,
          isInputError: details === translate("list.inncodes.already.exist")
        })
      );
    } else {
      const selectedFilter = response?.payload?.scList;
      const consultantList = cloneDeep(savedFilter.consultant);
      const lastIndex = consultantList.findLastIndex((item: any) => item.isFlagged === "Y");
      if (lastIndex > -1) {
        consultantList.splice(lastIndex + 1, 0, selectedFilter);
      } else {
        consultantList.splice(0, 0, selectedFilter);
      }
      const consultantListPayload = {
        data: consultantList,
        type: "consultant"
      };
      dispatch(setSelectedListCategory("consultant"));
      dispatch(setSelectedListRedux(selectedFilter));
      dispatch(
        resetPageModifiedFilter({
          pageName: [filterPage.listDisplay, filterPage.consultantListDisplay]
        })
      );
      dispatch(setCreatedSuccess({ isCreated: true, message: translate("list.created.success") }));
      dispatch(setSavedFilterByType(consultantListPayload));

      dispatch(setIsCreateInnCodeModal(false));
    }
  };

  const savedCreateList = async () => {
    const innCodes = inncodeList.map((data: any) => data.innCode);
    const request = {
      static: [
        {
          name: inputFieldData.name,
          description: inputFieldData.desc,
          isFlagged: "N",
          filters: [
            {
              id: null,
              key: "inncode",
              options: innCodes
            }
          ]
        }
      ]
    };
    clearDispatchErrorSuccess();
    const res = await dispatch(createFilterByType(request));
    const payload = res?.payload;
    if (payload?.status === 200) {
      const findIndex = res?.payload?.static?.findIndex((res: any) => res.name === inputFieldData.name);
      const selectedFilter = findIndex > -1 && res?.payload?.static?.[findIndex];

      const staticFilter = cloneDeep(savedFilter.static);
      const lastIndex = staticFilter.findLastIndex((item: any) => item.isFlagged === "Y");
      if (lastIndex > -1) {
        staticFilter.splice(lastIndex + 1, 0, selectedFilter);
      } else {
        staticFilter.splice(0, 0, selectedFilter);
      }
      const staticPayload = {
        data: staticFilter,
        type: "static"
      };
      dispatch(setSelectedListCategory("static"));
      dispatch(setSelectedListRedux(selectedFilter));
      dispatch(
        resetPageModifiedFilter({
          pageName: [filterPage.listDisplay, filterPage.consultantListDisplay]
        })
      );
      dispatch(setIsCreateInnCodeModal(false));
      dispatch(setCreatedSuccess({ isCreated: true, message: translate("list.created.success") }));
      dispatch(setSavedFilterByType(staticPayload));
    } else {
      const errors = payload?.data?.errors?.[0];
      const details = errors?.detail;
      dispatch(
        setCreateListError({
          isError: true,
          message: details,
          isInputError: details === translate("list.Filter.already.exist")
        })
      );
    }
  };

  const clearDispatchErrorSuccess = () => {
    dispatch(
      setCreateListError({
        isError: false,
        message: "",
        isInputError: false
      })
    );
    dispatch(setCreatedSuccess({ isCreated: false, message: "" }));
  };

  const isDisabled = () => {
    if (listType === "upload") {
      return inputFieldData.name === "" || isNull(file);
    }
    return inputFieldData.name === "" || !inncodeList.length;
  };

  useEffect(() => {
    return () => {
      resetData();
    };
  }, []);

  const allInncodes = () => {
    return inncodeList.map((innCode) => innCode.innCode);
  };

  const fetchFilters = async () => {
    const filters = ["default", "dynamic", "static", "bookmarked"];
    if (isConsultant) filters.push("consultant");
    await dispatch(fetchCorpSavedFilters({ types: filters }));
  };

  return (
    <>
      {isCreateInnCodeModal && (
        <DialogFormation
          title={listType === "upload" ? translate("list.uploadInncode") : translate("list.create.inncode.title")}
          handleClose={() => {
            dispatch(setIsCreateInnCodeModal(false));
          }}
          openDialog={isCreateInnCodeModal}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={() => {
                  dispatch(setIsCreateInnCodeModal(false));
                }}
              />
              <Button
                label={listType === "upload" ? "Import List" : "Save List"}
                disabled={isDisabled()}
                onClick={() => {
                  if (!isDisabled()) handleSubmit();
                }}
              />
            </div>
          }
          contentClass="create-list-content"
        >
          <div className="create-list-component">
            <div className="choose-types-wrapper">
              <div className="buttons-heading">
                <Typography component="span" color={tokens.Text.Feedback.Alert}>
                  *
                </Typography>{" "}
                <Typography variant="body2" color={tokens.Text.General.Secondary}>
                  {translate("list.chooseType")}
                </Typography>
              </div>
              <div className="multi-select-button">
                <FormControl className="list-form-control">
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedList}
                    onChange={handleChange}
                    className="list-radio-group"
                  >
                    <FormControlLabel
                      value="PROPERTY_LIST"
                      control={<Radio />}
                      label={
                        <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                          {translate("list.savedProperty.type")}
                        </Typography>
                      }
                    />
                    {isConsultant && (
                      <FormControlLabel
                        value="SC_LIST"
                        control={<Radio />}
                        label={
                          <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                            {translate("list.SC.type")}
                          </Typography>
                        }
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="list-name-wrapper">
              <div className="list-name">
                <Typography variant="body2" className="list-name-label" color={tokens.Text.General.Secondary}>
                  <span>*</span>
                  {translate("list.name.label")}
                </Typography>
                <TextField
                  error={createListError.isInputError}
                  className="list-name-input"
                  value={inputFieldData.name}
                  helperText={createListError.isInputError ? createListError.message : ""}
                  id="outlined-error"
                  onChange={(e: any) => {
                    handleInputChange("name", e.target.value);
                  }}
                  placeholder="List name"
                />
              </div>
              <div className="list-description">
                <Typography variant="body2" className="list-desc-label" color={tokens.Text.General.Secondary}>
                  {translate("common.description")}
                </Typography>
                <TextField
                  className="list-desc-input"
                  multiline
                  rows={4}
                  value={inputFieldData.desc}
                  onChange={(e: any) => {
                    handleInputChange("desc", e.target.value);
                  }}
                  placeholder="Description here"
                />
              </div>
            </div>
            {listType === "create" ? (
              <div className="inncodes-wrapper">
                <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} showBold>
                  <span style={{ color: "red" }}>*</span> {translate("list.addInncode.label")}
                </Typography>
                <div className="inncode-auto-complete">
                  <AutocompleteInncode
                    onSelect={handleInncodeChange}
                    isClearSearch={true}
                    placeholder="Search by Property or Inncode"
                    innCodeList={selectedList === "PROPERTY_LIST" && allInncodes()}
                  />
                </div>
                <div className="inncode-list">
                  {inncodeList.length > 0 &&
                    inncodeList.map((innCodes, index: number) => {
                      return (
                        <div className="inncode-list-wrapper" key={`${innCodes.innCode}-${index}`}>
                          <div className="inncodes-user">
                            <Typography variant="body2" showBold className="inncode-name">
                              {innCodes.innCode}
                            </Typography>
                            {selectedList === "SC_LIST" && (
                              <>
                                {!innCodes.user ? (
                                  <div
                                    className="add-users"
                                    onClick={() => {
                                      handleAddUser(innCodes.innCode, index);
                                    }}
                                  >
                                    <AddUser />
                                    <Typography variant="body2" showBold>
                                      {translate("common.addTeamMember")}
                                    </Typography>
                                  </div>
                                ) : (
                                  <div className="display-name">
                                    <Typography variant="body2">
                                      {getUserNameWithConditionalCheck(
                                        innCodes?.user?.displayName,
                                        innCodes?.user?.firstName,
                                        innCodes?.user?.lastName
                                      )}
                                    </Typography>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                          <div className="delete-icon" onClick={() => deleteInnCode(index, innCodes)}>
                            <CloseIconSmall />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            ) : (
              <div className="upload-file-wrapper">
                <div className="title-subtitle">
                  <Typography variant="body2" showBold color={tokens.Text.General.PrimaryBody}>
                    {translate("common.importFile")}
                  </Typography>
                  <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                    {translate("list.uploadFile.placeholder")}
                  </Typography>
                </div>
                <Link
                  type="button"
                  component="button"
                  className="download-template"
                  onClick={() => onDownloadClick("inncode-groups/template", "userplan")}
                >
                  {translate("list.downloadTemplate")}
                </Link>
                <div className="uploaded-file">
                  <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                    {translate("list.downloadTemplate.placeholder")}
                  </Typography>
                  <div style={{ position: "relative", marginTop: "16px" }}>
                    {file ? (
                      <div className="uploaded-file-name-container">
                        <div className="uploaded-file-name-wrapper">
                          <div className="create-left-wrapper">
                            <div className="file-icon">
                              <FileIcon />
                            </div>
                            <div className="file-name-size">
                              <Typography variant="body2" showBold color={tokens.Text.General.PrimaryHeadline}>
                                {file?.length ? file[0]?.name : ""}
                              </Typography>
                              <Typography variant="body2" color={tokens.Text.General.Secondary}>
                                {file.length ? `${(file[0]?.size / 1024 ** 2).toFixed(2)} MB` : ""}
                              </Typography>
                            </div>
                          </div>
                          <div className="right-wrapper" onClick={() => setFile(null)}>
                            <CrossNew />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Box
                          component="input"
                          type="file"
                          accept=".xlsx"
                          sx={{
                            position: "absolute",
                            zIndex: 1,
                            width: "200px",
                            borderRadius: "200px",
                            cursor: "pointer",
                            opacity: 0,
                            height: "100%"
                          }}
                          onChange={handleFileChange}
                        />
                        <Button variant="secondary" startIcon={<UploadFileIcon />} label={"Upload Excel File"} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <MapUserToInnCode
            isAddUserOpen={isAddUserOpen}
            handleClose={() => setAddUserOpen(false)}
            selectedInnCode={selectedInnCode}
            handleMemberList={handleMemberList}
            innCodeAssignee={innCodeAssignee}
          />
        </DialogFormation>
      )}
    </>
  );
};

export default CreateList;
